var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isNested)?_c('div',[_c('FormInputs',{attrs:{"context":_vm.context}})],1):_c('FormulateForm',{on:{"submit":_vm.onSubmit},model:{value:(_vm.keywordsForm),callback:function ($$v) {_vm.keywordsForm=$$v},expression:"keywordsForm"}},[_c('FormInputs',{attrs:{"context":_vm.context}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }